import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment.model';

import { CropVariety, GetCropVarietiesResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CropVarietyApiService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.APIM_BASE_URL}/arable-service/cropvariety`;

  getCropVarietiesByCropId(cropId: number): Observable<CropVariety[]> {
    return this.http.get<GetCropVarietiesResponse>(`${this.baseUrl}/cropId/${cropId}`).pipe(
      map((response) => {
        if (Array.isArray(response)) {
          return response as CropVariety[];
        }
        return response.cropVarieties;
      }),
    );
  }
}
